/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { getInstalledApiUrl } from '../../api/fetch-shim.js';

export interface GetImageProxyArgs {
  readonly url: string;
}

export function getImageProxy(args: GetImageProxyArgs): string {
  
  return getInstalledApiUrl() + `/v1/image-proxy` + ('?' + ['url=' + encodeURIComponent(args.url)].join('&'));
}
